<template>
  <div class="object-page-wrapper">
    <div class="page-content">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Условия покупки</h1>
        <div @click="$router.go(-1)" class="go-back-icon">
          <svg
            class="d-block ml-auto"
            xmlns="http://www.w3.org/2000/svg"
            width="17.999"
            height="18"
            viewBox="0 0 17.999 18"
          >
            <path
              id="Union_9"
              data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)"
              fill="#fefefc"
            />
          </svg>
        </div>
      </div>

      <div class="some-text-3 text-white">
        <p>
          Ипотечные кредиты предоставляются нашим партнером по проекту -
          Ташкентским городским филиалом ХАМКОРБАНКА
        </p>
      </div>

      <div class="purchase-term-items flex-container text-white">
        <div class="flex-container__left">
          <span class="d-block mt-n2">Условия и сроки кредитования:</span>
        </div>
        <div class="flex-container__right flex-container f-between">
          <div class="flex-half">
            <span>При оплате первоначального взноса:</span>
            <p>от 25% до 35% – 10 лет.</p>

            <span>При оплате первоначального взноса:</span>
            <p>от 35% до 50% - 12 лет.</p>
          </div>
          <div class="flex-half">
            <div class="time-interval">
              <span>Льготный период:</span>
              <p>6 месяцев.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="purchase-term-items flex-container text-white">
        <div class="flex-container__left">
          <span class="d-block mt-n2">Процентные ставки ипотечного кредитования:</span>
        </div>
        <div class="flex-container__right">
          <div class="term-item-text d-flex f-between align-center">
            <span>Первоначальный взнос:</span>
            <span>Кредитная ставка:</span>
          </div>
          <div class="term-item-text d-flex f-between align-center">
            <p>25% и выше.</p>
            <small>14 % годовых.</small>
          </div>
          <div class="term-item-text d-flex f-between align-center">
            <p>30% и выше.</p>
            <small>13 % годовых.</small>
          </div>
          <div class="term-item-text d-flex f-between align-center">
            <p>35% и выше.</p>
            <small>12 % годовых.</small>
          </div>
          <div class="term-item-text d-flex f-between align-center">
            <p>50% и выше.</p>
            <small>10 % годовых.</small>
          </div>
        </div>
      </div>

      <div class="purchase-term-items flex-container text-white">
        <div class="flex-container__left">
          <span class="d-block mt-n2">Необходимые документы:</span>
        </div>
        <div class="flex-container__right">
          <ul class="term-items-ul p-0 m-0">
            <li>
              <span>Заявление</span>
            </li>
            <li>
              <span>Ксерокопия паспорта</span>
            </li>
            <li>
              <span>
                Справка с место работы о доходах за последний один год, с
                указанием стажа работы, ИНН и ИНПС. (в случае если ежемесячный
                доход клиента не покрывает сумму ежемесячной оплаты кредита, по
                желанию родственники могут выступить как гаранты)
              </span>
            </li>
            <li>
              <span>Договор купли продажи дома</span>
            </li>
            <li>
              <span>Cправка с махалли о составе семьи</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="purchase-term-items flex-container text-white">
        <div class="flex-container__left">
          <span class="d-block mt-n2">Контактные данные:</span>
        </div>
        <div class="flex-container__right">
          <span>Адрес:</span>
          <p>
            Адрес. Чиланзарский район, ул Фурката, 14
            <i class="sub-text">
              На против дворца культуры «Истиклал» (бывш. Дворец Дружбы
              народов)
            </i>
          </p>

          <br />

          <span>Обратная связь:</span>
          <p>
            +998 (71) 120 18 08 – Жамолиддин
            <i class="sub-text">сотрудник кредитного отдела</i>
          </p>

          <br />

          <p>
            +998 (90) 968 76 67 – Абдухалим
            <i class="sub-text">начальник кредитного отдела</i>
          </p>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation";
export default {
  components: {
    BottomNavigation
  }
};
</script>

<style></style>
